import ReactDOM from "react-dom/client";
import { Suspense } from "react";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import "./index.css";
import { store } from "./redux/app/store";
import { queryClient } from "./queryClient";
import Loader from "./components/ui/loader";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </Provider>
  </QueryClientProvider>
);
